var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.getExtensionOptionLabel(),
            placement: "top",
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled
          }
        },
        [
          _c("CompassIconButton", {
            ref: "linkRichTextTrigger",
            attrs: {
              icon: _vm.getExtensionOptionIcon(),
              size: "small",
              disabled: _vm.disabled,
              active: _vm.activeStyle(_vm.option) || _vm.showMenuLink
            },
            on: { click: _vm.showLinkMenu }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          attrs: {
            title: _vm.$t.__("richtext.customoptions.LinkRichText.add_link"),
            customClass: "custom-popover-link",
            triggerRef: "linkRichTextTrigger",
            isVisible: _vm.showMenuLink
          },
          on: { close: _vm.hideLinkMenu }
        },
        [
          _c(
            "div",
            { staticClass: "link-form-container" },
            [
              _c(
                "CompassFormItem",
                {
                  staticClass: "link-form-item-link",
                  attrs: {
                    label: _vm.$t.__(
                      "richtext.customoptions.LinkRichText.link"
                    ),
                    disabled: _vm.disabled,
                    required: "",
                    requiredLabel: _vm.$t.__("common.labels.required"),
                    error: _vm.errorUrlLink
                  }
                },
                [
                  _c("CompassInput", {
                    ref: "refInputLink",
                    attrs: {
                      disabled: _vm.disabled,
                      error: !!_vm.errorUrlLink
                    },
                    model: {
                      value: _vm.urlLink,
                      callback: function($$v) {
                        _vm.urlLink = $$v
                      },
                      expression: "urlLink"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.urlLink
                ? _c("CompassLink", {
                    staticClass: "link-test",
                    class: _vm.errorUrlLink ? "link-test-error" : "",
                    attrs: {
                      label: _vm.$t.__(
                        "richtext.customoptions.LinkRichText.test_link"
                      ),
                      size: "small",
                      link: _vm.normalizeURL(_vm.urlLink),
                      target: "_blank"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "suffix",
                          fn: function() {
                            return [
                              _c("CompassIcon", {
                                attrs: { icon: "external-link", size: "small" }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3942976159
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("CompassCheckbox", {
                staticClass: "link-target",
                attrs: {
                  modelValue: "targetLink",
                  label: _vm.$t.__(
                    "richtext.customoptions.LinkRichText.open_new_tab"
                  ),
                  checked: _vm.targetLink,
                  showLabel: "",
                  disabled: _vm.disabled
                },
                on: {
                  change: function($event) {
                    _vm.targetLink = !_vm.targetLink
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "link-container-action" },
                [
                  _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.$t.__(
                        "richtext.customoptions.LinkRichText.delete_link"
                      ),
                      size: "small",
                      disabled: !_vm.urlLink
                    },
                    on: { click: _vm.unUrlLink }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.cancel"),
                      type: "secondary",
                      size: "small"
                    },
                    on: { click: _vm.hideLinkMenu }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.validate"),
                      size: "small"
                    },
                    on: { click: _vm.setUrlLink }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }